import { resourceExplorerViewsDataSelector } from "./resourceExplorerViewsDataSelector";
import { RootState } from "../../../store";

export const viewNotFoundSelector = (state: RootState, viewId: string) => {
  const views = resourceExplorerViewsDataSelector(state);

  return !views.find((item) => item.id === viewId);
};
